import React from 'react';

import { FormComponent, ModalComponent, UiComponent } from 'components';
import { IPartner } from 'types';
import useModal from 'hooks/useModal';
import { FileServiceQuery } from 'queries';
import useFileService from 'hooks/useFileService';
import { mobile } from 'styles/media';

interface Props {
  partner?: IPartner;
  onClose: () => void;
  onSave: (partner: IPartner, newFile?: File | null) => void;
}

function Modal({ partner, onClose, onSave }: Props) {
  const { handleAlert } = useModal();
  const { handleUploadd: upload } = FileServiceQuery.useUpload();
  const { fileUrl, file, handleFile } = useFileService({
    initFileUrl: partner?.thumbnail,
  });

  const submit = async (data: IPartner) => {
    if (!fileUrl) {
      handleAlert('로고를 업로드해주세요');
      return;
    }

    let thumbnail = fileUrl;
    if (file) {
      const res = await upload(file);
      if (!res) return;
      thumbnail = res.data.url;
    }

    onSave({ ...data, thumbnail }, file);
  };

  return (
    <ModalComponent.Portal>
      <ModalComponent.Background>
        <ModalComponent.Modal title="" handleClose={onClose} footer={<></>}>
          <FormComponent.Form
            submit={submit}
            css={{
              display: 'flex',
              flexDirection: 'column',
              gap: '8px 0',
              width: '500px',
              maxWidth: '100%',
            }}
          >
            <p>로고</p>
            <UiComponent.FileUpload
              name="thumbnail"
              fileUrl={fileUrl}
              handleFile={handleFile}
            />

            <p>이름</p>
            <FormComponent.Input
              type="text"
              name="name"
              defaultValue={partner?.name}
            />
            <p>설명</p>
            <FormComponent.Input
              type="text"
              name="description"
              defaultValue={partner?.description}
            />
            <UiComponent.Button
              type="submit"
              variant="contained"
              color="primary"
              css={{
                width: '120px',
                margin: '8px auto 0',
                [mobile]: { width: '100%', height: 48 },
              }}
            >
              저장
            </UiComponent.Button>
          </FormComponent.Form>
        </ModalComponent.Modal>
      </ModalComponent.Background>
    </ModalComponent.Portal>
  );
}

export default Modal;
